<template>
    <div class="dev-list">
        <div class="dev-list-search">
            <div class="search-btn">
                <div style="display: flex;flex-direction: row;">
                    <el-button size="small" type="primary" @click="$router.push('/home/app/upload')"
                               v-if="$store.getters.checkChangeAuth() || !$store.state.isAdmin">新增/更新应用
                    </el-button>
                    <el-button size="small" type="primary" @click="openAppBlack"
                               v-if="$store.getters.checkChangeAuth() || $store.state.userInfo.groupType === 1">业务应用黑名单
                    </el-button>
                </div>

                <div @keyup.enter="getAppListForSearch">
                    <el-input size="small" placeholder="输入应用名称/apk名称/APPID 搜索" v-model="searchInfo.appNameLike"
                              style="width: 320px">
                        <el-button slot="append" icon="el-icon-search" @click="getAppListForSearch"></el-button>
                    </el-input>
                </div>
            </div>
        </div>
        <div class="device-case-dev border-all">
            <el-table ref="multipleTable" :data="info.list" :header-cell-style="{backgroundColor: '#efefef'}"
                      :height="tableHeight" size="mini" @row-click="goDetail" tooltip-effect="dark" style="width: 99%"
                      @selection-change="handleSelectionChange">
                <el-table-column prop="appName" label="应用名称"></el-table-column>
                <el-table-column prop="packageName" label="包名"></el-table-column>
                <el-table-column prop="versionName" label="版本"></el-table-column>
                <el-table-column prop="appId" label="APPID"></el-table-column>
                <el-table-column prop="remark" label="备注"></el-table-column>
                <el-table-column min-width="120px" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click.stop="goGroup(scope.row)">分组</el-button>
                        <el-button type="text" size="small"
                                   v-if="$store.state.userInfo.groupType !== 2 && ($store.getters.checkChangeAuth() || !$store.state.isAdmin) || scope.row.userId == $store.state.userInfo.id"
                                   @click.stop="apkOffBatch(scope.row)">下架
                        </el-button>
                        <el-button type="text" size="small" @click.stop="goDetail(scope.row)"
                                   v-if="scope.row.userId == 0 && $store.state.userInfo.groupType !== 2 || scope.row.userId == $store.state.userInfo.id">
                            编辑
                        </el-button>
                        <el-tooltip effect="dark" content="业务用户上传应用，管理员不可编辑" placement="top-start"
                                    v-else>
                            <el-button type="text" size="small" @click.stop="()=>{}" style="color: #aaa" v-if="$store.state.userInfo.groupType !== 2">编辑</el-button>
                        </el-tooltip>
                        <el-button type="text" size="small" @click.stop="changeRemark(scope.row)"
                                   v-if="scope.row.userId == 0 && $store.state.userInfo.groupType !== 2 || scope.row.userId == $store.state.userInfo.id">
                            修改备注
                        </el-button>
                        <el-tooltip effect="dark" content="业务用户上传应用，管理员不可编辑" placement="top-start"
                                    v-else>
                            <el-button type="text" size="small" @click.stop="()=>{}" style="color: #aaa" v-if="$store.state.userInfo.groupType !== 2">修改备注
                            </el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="list-bottom">
                <div class="list-bottom-btn">
                </div>
                <el-pagination
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="page.startPage"
                        :page-sizes="[10, 20, 50]"
                        :page-size="page.limit"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next"
                        :total="info.total">
                </el-pagination>
            </div>
            <!-- 上传应用 -->
            <el-dialog title="新增应用" ref="uploadPop" :append-to-body="true"
                       :close-on-click-modal="false" :show-close="false" top="15vh"
                       :visible.sync="addAppPopShow" width="500px">
                <div>
                    <el-form ref="form" :model="addAppExtraInfo" label-width="180px" label-position="left">
                        <el-form-item size="mini" label="是否授权">
                            <el-switch v-model="addAppExtraInfo.isRoot"
                                       active-value="1"
                                       inactive-value="0"></el-switch>
                        </el-form-item>
                        <el-form-item size="mini" label="是否预启动">
                            <el-switch v-model="addAppExtraInfo.isPrestart"
                                       active-value="1"
                                       inactive-value="0"></el-switch>
                        </el-form-item>
                        <el-form-item size="mini" label="是否上传定位信息">
                            <el-switch v-model="addAppExtraInfo.isUploadLocationInfo"
                                       active-value="1"
                                       inactive-value="0"></el-switch>
                        </el-form-item>
                        <el-form-item size="mini" label="是否开启传感器">
                            <el-switch v-model="addAppExtraInfo.isSensor"
                                       active-value="1"
                                       inactive-value="0"></el-switch>
                        </el-form-item>
                        <el-form-item size="mini" label="退出是否清理用户数据">
                            <el-switch v-model="addAppExtraInfo.isClean"
                                       active-value="1"
                                       inactive-value="0"></el-switch>
                        </el-form-item>
                        <el-form-item size="mini" label="退出后是否重启设备">
                            <el-switch v-model="addAppExtraInfo.isReboot"
                                       active-value="1"
                                       inactive-value="0"></el-switch>
                        </el-form-item>
                        <el-form-item size="mini" label="退出后是否关闭应用">
                            <el-select v-model="addAppExtraInfo.isStopApp" placeholder="请选择" size="small">
                                <el-option label="关闭应用" value="0"></el-option>
                                <el-option label="不关闭并放入后台" value="1"></el-option>
                                <el-option label="不关闭并留在前台" value="2"></el-option>
                            </el-select>
                        </el-form-item>

                        <div class="popup-flex">
                            <el-upload
                                    class="upload-demo"
                                    ref="upload"
                                    :headers="$store.getters.getHeaders"
                                    :action="$uri.apk.apkNewAdd"
                                    :data="addAppExtraInfo"
                                    :file-list="addAppFileList"
                                    accept=".apk"
                                    :limit="1"
                                    :multiple="false"
                                    :on-success="handleSuccess"
                                    :before-upload="handleUpload"
                                    :on-progress="handleProgress"
                                    :auto-upload="false">
                                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                                <div slot="tip" class="el-upload__tip">只能上传apk文件</div>
                            </el-upload>
                            <div style="margin-top: 20px" ref="www">
                                <el-button type="primary" :disabled="addAppPopCloseTip" @click="submitUpload">确定
                                </el-button>
                                <el-button @click="tipFileUpload">取消</el-button>
                            </div>
                        </div>
                    </el-form>
                </div>
            </el-dialog>
            <!-- 修改备注弹窗 -->
            <Drawer
                    title="修改备注"
                    :visible.sync="changeRemarkPopShow"
                    @handClick="changeRemarkProcess"
            >
                <el-form size="mini" label-width="120px"
                         label-position="left">
                    <el-form-item label="应用名称：">{{ changeAppInfo.appName }}</el-form-item>
                    <el-form-item label="包名：">{{ changeAppInfo.packageName }}</el-form-item>
                    <el-form-item label="版本：">{{ changeAppInfo.versionName }}</el-form-item>
                    <el-form-item label="备注名称：" size="mini">
                        <el-input size="mini" v-model.trim="changeAppInfo.remark"></el-input>
                    </el-form-item>
                </el-form>
            </Drawer>
            <!-- 业务应用黑名单弹窗 -->
            <Drawer
                    title="业务应用黑名单"
                    :opt="false"
                    :visible.sync="appBlackListPopShow"
            >
                <el-form size="mini">
                    <el-table
                            :data="appBlackList.list"
                            size="mini"
                            ref="appBlackTable"
                            max-height="500"
                            highlight-current-row
                            style="width: 100%"
                    >
                        <el-table-column prop="packageName" label="包名" min-width="180px"></el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                                <el-button
                                        type="text"
                                        size="small"
                                        @click="deleteAppBlack(scope.row.id)"
                                >
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="app-list-bottom">
                        <div class="app-list-bottom-btn">
                        </div>
                        <el-pagination
                                small
                                @size-change="blackAppSizeChangeHandle"
                                @current-change="blackAppCurrentChangeHandle"
                                :current-page="blackpage.startPage"
                                :page-sizes="[5, 10, 20]"
                                :page-size="blackpage.limit"
                                :pager-count="5"
                                layout="total, sizes, prev, pager, next"
                                :total="appBlackList.total">
                        </el-pagination>
                    </div>
                    <el-form-item size="mini" style="margin-top: 20px;" label="新增黑名单应用：">
                    </el-form-item>
                    <el-form-item size="mini" style="margin-top: -10px;">
                        <el-input maxlength="20" size="mini" v-model.trim="packageToBlack" placeholder="请输入包名"
                                  style="width: 200px; margin-right: 20px;"></el-input>
                        <el-button
                                type="primary"
                                size="small"
                                @click="addAppToBlackList()"
                        >
                            添加
                        </el-button>
                    </el-form-item>
                </el-form>
            </Drawer>
        </div>
    </div>

</template>

<script>
    import Drawer from "@/components/Drawer";

    export default {
        name: "AppList",
        components: {Drawer},
        data() {
            return {
                appBlackListPopShow: false,
                changeRemarkPopShow: false,
                appBlackList: {},
                packageToBlack: "",
                changeAppInfo: {},
                tableHeight: 0,
                // blackTableHeight: 0,
                info: {
                    success: false,
                    list: [],
                    total: 0
                },
                page: { // 分页参数
                    startPage: 1,
                    limit: 10
                },
                blackpage: { // 分页参数
                    startPage: 1,
                    limit: 5
                },
                multipleSelection: [], // 选中的对象列表
                addAppPopShow: false, // 显示添加应用弹窗
                addAppPopCloseTip: false,
                addAppExtraInfo: {
                    isRoot: "0",
                    appIdUpdate: 0,
                    isPrestart: "0",
                    isClean: "0",
                    isReboot: "0",
                    isSensor: "0",
                    isUploadLocationInfo: "0",
                    isStopApp: "0"
                },
                addAppFileList: [],
                searchInfo: {
                    appNameLike: "",
                    apkNameLike: "",
                    appId: "",
                    apkStatus: 1
                }
            }
        },
        methods: {
            openAppBlack() {
                this.getAppBlackList()
                this.appBlackListPopShow = true
            },
            addAppToBlackList() {
                let that = this
                if (that.packageToBlack.length == 0) {
                    this.$confirm('请输入包名', '提示', {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        showCancelButton: false
                    }).then(() => {
                    }).catch(() => {
                    });
                    return
                }
                that.$post(that.$uri.apkBlack.add, {packageName: that.packageToBlack}).then(res => {
                    if (res.success) {
                        that.getAppBlackList()
                        that.packageToBlack = ""
                    }
                })
            },
            deleteAppBlack(id) {
                let that = this
                that.$post(that.$uri.apkBlack.delete, {id: id}).then(res => {
                    if (res.success) {
                        that.getAppBlackList()
                    }
                })
            },
            getAppBlackList() {
                let that = this
                that.$post(that.$uri.apkBlack.list, {...that.blackpage}).then(res => {
                    if (res.success) {
                        that.appBlackList = res
                    }
                })
            },
            /* 表单击行事件 */
            checkRow(r, c, e) {
                this.$refs.multipleTable.toggleRowSelection(r)
            },
            /* 获取应用列表 */
            getAppList() {
                this.searchInfo.apkNameLike = this.searchInfo.appNameLike
                this.searchInfo.appid = this.searchInfo.appNameLike
                this.$post(this.$uri.apk.apkList, {
                    ...this.page,
                    apkStatus: 1,
                    queryParam: this.searchInfo.appNameLike
                }).then(res => {
                    this.info = res
                    // console.log("res is " + JSON.stringify(res))
                    this.$nextTick().then(() => {
                        if (this.$refs.multipleTable) {
                            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                        }
                    })
                })
            },
            getAppListForSearch() {
                this.searchInfo.apkNameLike = this.searchInfo.appNameLike
                this.searchInfo.appid = this.searchInfo.appNameLike
                this.page.startPage = 1
                this.$post(this.$uri.apk.apkList, {
                    ...this.page,
                    apkStatus: 1,
                    queryParam: this.searchInfo.appNameLike
                }).then(res => {
                    this.info = res
                    // console.log("res is " + JSON.stringify(res))
                    this.$nextTick().then(() => {
                        if (this.$refs.multipleTable) {
                            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 200;
                        }
                    })
                })
            },
            /* 当前页改变 */
            currentChangeHandle(val) {
                this.page.startPage = val
                this.getAppList()
            },
            /* 每页条数改变 */
            sizeChangeHandle(val) {
                this.page.limit = val
                this.getAppList()
            },
            /* 当前页改变 */
            blackAppCurrentChangeHandle(val) {
                this.blackpage.startPage = val
                this.getAppBlackList()
            },
            blackAppSizeChangeHandle(val) {
                this.blackpage.limit = val
                this.getAppBlackList()
            },
            /* 获取选中的数据 */
            handleSelectionChange(val) {
                this.multipleSelection = val
                // console.log(this.multipleSelection)
            },
            /* 下架应用 */
            async apkOff(id) {
                let that = this
                await that.$post(that.$uri.apk.apkOff, {id})
            },
            /* 批量下架应用 */
            apkOffBatch(row) {
                let that = this
                this.$confirm('下架后安装应用的云机会对应用进行卸载， 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    confirmButtonClass: 'confirm-btn-blue',
                    iconClass: 'el-icon-c-blue',
                    cancelButtonText: '取消'
                }).then(() => {
                    that.$post(that.$uri.apk.apkOff, {ids: [row.id]}).then(res => {
                        this.$message.success("下架完成")
                        this.getAppList()
                    })
                }).catch(() => {
                });
            },
            /* 关闭弹窗并暂停文件传输 */
            closeUploadPop() {
                this.addAppPopShow = false
                this.addAppPopCloseTip = false
                this.$refs.upload.clearFiles()
            },
            /* 上传文件 */
            submitUpload() {
                this.$refs.upload.submit()
            },
            /* 文件传输成功回调 */
            handleSuccess(response, file, fileList) {
                if (response.success) {
                    this.addAppPopShow = false
                    this.$message.success(response.message)
                    this.closeUploadPop()
                    this.getAppList()
                } else {
                    // console.log(response)
                    this.$message.error(response.message)
                    this.$refs.upload.clearFiles()
                }
            },
            handleProgress(event, file, fileList) {
                if (!this.addAppPopShow) {
                    this.$refs.upload.abort(file)
                    this.$refs.upload.clearFiles()
                }
            },
            handleUpload() {
                this.addAppPopCloseTip = true
            },
            /* 上传文件中关闭弹窗提醒 */
            tipFileUpload() {
                if (this.addAppPopCloseTip) {
                    this.$confirm("文件正在上传中，确定关闭弹窗？", "提示", {
                        confirmButtonText: '确定',
                        confirmButtonClass: 'confirm-btn-blue',
                        iconClass: 'el-icon-c-blue',
                        cancelButtonText: '取消'
                    }).then(() => {
                        this.closeUploadPop()
                    }).catch(() => {
                    })
                } else {
                    this.closeUploadPop()
                }
            },
            /* 前往详情页 */
            goDetail(info) {
                this.$store.commit(this.$mutation.APP_DETAIL, info)
                this.$router.push("/home/app/detail")
            },
            /* 前往分组页 */
            goGroup(info) {
                this.$store.commit(this.$mutation.APP_DETAIL, info)
                this.$router.push("/home/app/group")
            },
            /*修改备注弹窗*/
            changeRemark(info) {
                this.changeAppInfo = JSON.parse(JSON.stringify(info))
                this.changeRemarkPopShow = true
                // console.log("info is " + JSON.stringify(info))
            },
            changeRemarkProcess() {
                let that = this;
                that.$post(that.$uri.apk.apkInfoSave, {...that.changeAppInfo}).then(res => {
                    if (res.success) {
                        // console.log("allMirrorList is " + JSON.stringify(res.list))
                        that.getAppList()
                    }
                }).finally(() => {
                    that.changeRemarkPopShow = false
                })

            }
        },
        filters: {},
        mounted() {
            this.getAppList()
            // console.log(JSON.stringify(this.$store.state.userInfo))
        }
    };
</script>

<style lang="less" scoped>
    .dev-list {
        .dev-list-search {
            width: 100%;
            display: flex;
            flex-direction: column;
            .search-btn {
                display: flex;
                flex-direction: row;
                justify-content: space-between;
            }
        }
        .device-case-dev {
            margin-top: 10px;
            .list-bottom {
                padding: 10px 8px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .list-bottom-btn {
                    display: flex;
                    flex-direction: row;
                }
            }
        }
    }

    .app-list-bottom {
        padding: 10px 8px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        .app-list-bottom-btn {
            display: flex;
            flex-direction: row;
        }
    }
</style>